import { useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, BookOpenActive } from '@/assets/svgs/BookOpen';
import { hapticsImpactLight } from '../utils/haptics';
import { MCGRAW_HILL_PATH } from './mcgrawHill';
import { useMcGrawHillVerticalScope } from './mcgrawHillVerticalScope';

/**
 * mcgraw-hill (ORA-1247): Textbooks, the catalog, below Self-Assessments. It
 * opens the member's vertical's shelf.
 */
export const McGrawHillTextbooksNavItem = ({
  iconsOnly,
}: {
  iconsOnly: boolean;
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { catalogCategory } = useMcGrawHillVerticalScope();

  const isActive =
    pathname === MCGRAW_HILL_PATH ||
    pathname.startsWith(`${MCGRAW_HILL_PATH}/`);

  // Its own section below the study tools, behind the nav's usual divider.
  return (
    <>
      <div className="navbar_options_divider"></div>
      <button
        className={`navbar_options_option ${isActive ? 'active' : ''}`}
        onClick={() => {
          hapticsImpactLight();
          navigate(`${MCGRAW_HILL_PATH}/${catalogCategory}`);
        }}
        aria-label="Navigate to Textbooks"
        aria-current={isActive ? 'page' : undefined}
        tabIndex={iconsOnly ? -1 : 0}
        type="button"
      >
        {isActive ? <BookOpenActive /> : <BookOpen />}
        <span>Textbooks</span>
      </button>
    </>
  );
};
